import { apiConnection } from "@/services/api-connection";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";

const URL_QUESTIONNAIRES = "/app/questionnaire/list/";
const URL_QUESTIONNAIRE = "/app/questionnaire/";
const URL_POST = "/app/questionnaire/save/";
const URL_PDF = "/app/questionnaire/export/";

class QuestionnaireApiService {
  postAdminQuestionnaire(data, trainingCourseId, id = null) {
    const url = "/app/studea-manager/" + trainingCourseId + "/questionnaire";
    return (id ? apiConnection.put(url + "/" + id, data) : apiConnection.post(url, data)).then((response) => response);
  }

  getAdminQuestionnaireList(trainingCourseId) {
    const url = "/app/studea-manager/" + trainingCourseId + "/questionnaires";
    return apiConnection.get(url, {}).then((response) => response);
  }

  getAdminQuestionnaire(id, trainingCourseId, exp = false) {
    const url = "/app/studea-manager/" + trainingCourseId + "/questionnaire/" + (exp ? "export/" : "") + id;
    return apiConnection.get(url, {}).then((response) => response);
  }

  loadQuestionnaires = (id) => {
    return apiConnection.get(URL_QUESTIONNAIRES + id, {}, true).then((response) => response);
  };

  loadQuestionnaire = (questionnaireId, triadId) => {
    return apiConnection
      .get(URL_QUESTIONNAIRE + triadId + "/" + questionnaireId, {}, true)
      .then((response) => response);
  };

  getPdf = (triadId, questionnaireId, model = 0) => {
    return apiConnection.get(URL_PDF + triadId + "/" + questionnaireId, { model: model }).then((res) => {
      messengerMessageManager.processMessage(res);
    });
  };

  postQuestionnaire = (questionnaireId, triadId, draft, model, profile) => {
    if (!model) {
      model = [];
    }
    return apiConnection
      .put(
        URL_POST + triadId + "/" + questionnaireId,
        {
          draft: draft,
          model: model,
          profile: profile,
        },
        true,
      )
      .then((response) => response);
  };

  addRow(triadId, questionnaireId, clusterId) {
    return apiConnection
      .post("/app/questionnaire/add-row/" + triadId + "/" + questionnaireId + "/" + clusterId)
      .then((answer) => answer);
  }

  copyQuestionnaire(triadId, questionnaireId, params) {
    return apiConnection
      .post("/app/questionnaire/copy-questionnaire/" + triadId + "/" + questionnaireId, params)
      .then((response) => response);
  }

  removeQuestionnaire(questionnaireId) {
    return apiConnection
      .delete("/app/questionnaire/remove-questionnaire/" + questionnaireId)
      .then((response) => response);
  }

  addComment(triadId, questionnaireId, answerId, comment) {
    return apiConnection
      .post("/app/questionnaire/add-comment/" + triadId + "/" + questionnaireId + "/" + answerId, {
        comment: comment,
      })
      .then((comment) => comment);
  }

  toggleQuestionnaireActive(trainigCourseId, id) {
    return apiConnection
      .get("/app/studea-manager/" + trainigCourseId + "/questionnaire/toggle-active/" + id)
      .then((res) => res);
  }
}

export const questionnaireApiService = new QuestionnaireApiService();
